type CommerceCodeParams = {
  brand: string
  country: string
  ecommerceCode: string | null
  ecommerceTransactionHost?: string
}

/**
 * Format the commerce code based on the brand and current commerce transaction host:
 *
 * {ecommerceCode}-{brand}-{country}-{hostname}
 */
export const formatCommerceCode = (params: CommerceCodeParams): string | null => {
  const { brand, country, ecommerceCode, ecommerceTransactionHost } = params
  const locale = country?.toLowerCase()

  if (isSimulator(ecommerceCode)) {
    return `${brand}-${locale}-fesimulator`
  }

  const code = getBaseCommerceCode(params)
  const suffix = getHostnameSuffix(ecommerceTransactionHost)
  return code ? `${code}${suffix}` : `${ecommerceCode?.toLocaleLowerCase()}${suffix}`
}

export const isSimulator = (ecommerceCode: string | null): boolean => ecommerceCode === null

const getBaseCommerceCode = (params: CommerceCodeParams): string | null => {
  const { brand, country, ecommerceCode } = params
  const locale = country?.toLowerCase()
  const code = ecommerceCode?.toLowerCase()

  if (locale) {
    return `${code}-${brand}-${locale}`
  }

  return null
}

const getHostnameSuffix = (ecommerceTransactionHost?: string): string => {
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname.includes('local.')

  // NOTE: need to use transactionHost for local dev as
  // commerce code of *-localhost will not correctly map to b/e
  if (isLocal && ecommerceTransactionHost) {
    try {
      const url = new URL(ecommerceTransactionHost)
      return `-${url.hostname}`
    } catch (_error) {
      return `-${ecommerceTransactionHost}`
    }
  }
  return `-${window.location.hostname}`
}
